import { colors, Grid } from '@material-ui/core'
import React from 'react'
import { css } from 'react-emotion'

import { MainContainer } from '../atoms/MainContainer'
import { UserBanner } from '../atoms/UserBanner'
import { SwitchBar } from './SwitchBar'

interface IProps {}

const topBarBackground = css`
  background-color: ${colors.blue[200]};
`

export const MainLayout: React.FC<IProps> = ({ children }) => (
  <MainContainer>
    <Grid item container className={topBarBackground}>
      <Grid item xs={10}>
        <SwitchBar />
      </Grid>
      <Grid item xs={2}>
        <UserBanner />
      </Grid>
    </Grid>
    <Grid item>{children}</Grid>
  </MainContainer>
)
